<template>
  <div>
    <Headers :windowWidth="windowWidth" />
    <div class="createAccount_wrap">

      <div class="top_tlt">Approval Process Management</div>

      <!-- 搜索 -->
      <div class="search">
          <el-row type="flex" align="bottom"  :gutter="20">
              <el-col :span="7">
                  <div class="search_t">Module</div>
                  <el-select v-model="fromData.module" style="width:100%" clearable placeholder="All">
                      <el-option
                      v-for="item in moduleList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      </el-option>
                  </el-select>
              </el-col>
              <el-col :span="7">
                  <div class="search_t">Operation</div>
                  <el-select v-model="fromData.operation" style="width:100%" clearable placeholder="All">
                      <el-option
                      v-for="item in operationList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      </el-option>
                  </el-select>
              </el-col>
              <el-col :span="7">
                  <div class="search_t">Tier(s)</div>
                  <el-select v-model="fromData.tier" style="width:100%" clearable placeholder="All">
                      <el-option
                      v-for="item in tierList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      </el-option>
                  </el-select>
              </el-col>
              <el-col :span="3">
                  <div class="search_btn" @click="getlistByapproveProcess">Search</div>
              </el-col>
          </el-row>
      </div>

      <!-- 表格 -->
      <el-table
        :data="tabList"
        stripe
        :header-cell-style="{
          background: '#F0F3F6',
          color: '#626262',
          fontSize: '14px',
          fontFamily: 'ArialMT',
          paddingTop: '17px',
          paddingBottom: '15px',
          paddingLeft: '20px',
        }"
        :cell-style="columnStyle"
        style="width: 100%"
      >
        <!-- 空状态 -->
        <template slot="empty">
          <p style="margin-top: 50px">
            <img class="data-pic" src="../../assets/img/noData.png" alt="" />
          </p>
          <p class="nodata">No Data</p>
        </template>
        <el-table-column prop="module" label="Module">
            <template slot-scope="scope">
                <div v-if="scope.row.module == '1'">Account Management</div>
                <div v-if="scope.row.module == '2'">ICC Management</div>
            </template>
        </el-table-column>
        <el-table-column prop="operation" label="Operation">
            <template slot-scope="scope">
                <div v-if="scope.row.operation == '1'">Company Account Review</div>
                <div v-if="scope.row.operation == '2'">Agency Account Review</div>
                <div v-if="scope.row.operation == '3'">Transfer Review</div>
                <div v-if="scope.row.operation == '4'">Retirement Review</div>
            </template>
        </el-table-column>
        <el-table-column prop="tier" label="Tier(s)"></el-table-column>
        <el-table-column prop="operatorName" label="Operator"></el-table-column>
        <el-table-column prop="updateTime" label="Update Time">
            <template slot-scope="scope">
                {{ formatDates(scope.row.updateTime) }}
            </template>
        </el-table-column>
        <el-table-column :label="$t('createAccount.action')">
            <template slot-scope="scope">
                <div class="flex_box">
                    <div class="txt Reactive" @click="gotoEdit(scope.row)">Edit</div>
                </div>
            </template>
        </el-table-column>
      </el-table>


      <el-row type="flex" justify="space-between" style="margin-top:20px">
          <el-col>
              <el-button class="save back" @click="back">{{$t('createAccount.Back')}}</el-button>
          </el-col>
      </el-row>
    </div>

    
  </div>
</template>
<script>
import Headers from "@/components/header/index.vue";
import carbon from "@/api/carbon.js";
import { formatDate } from '@/util/date.js'
  export default {
    components: { Headers },
    data() {
      return {
        windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
        status: false,
        checkList: [],
        fromData:{
            module:"",
            operation:"",
            tier:"",
        },
        moduleList:[
            {
                value: '1',
                label: 'Account Management'
            },
            {
                value: '2',
                label: 'ICC Management'
            },
        ],
        operationList:[
            {
                value: '1',
                label: 'Company Account Review'
            },
            {
                value: '2',
                label: 'Agency Account Review'
            },
            {
                value: '3',
                label: 'Transfer Review'
            },
            {
                value: '4',
                label: 'Retirement Review'
            },
        ],
        tierList:[
            {
                value: '1',
                label: '1'
            },
            {
                value: '2',
                label: '2'
            },
            {
                value: '3',
                label: '3'
            },
        ],
        tabList: [],
        pageSize: 10,
        currentPage: 1,
      };
    },
    mounted() {
      this.getlistByapproveProcess()
      let that = this;
      window.onresize = () => {
        return (() => {
          window.fullWidth = document.documentElement.clientWidth;
          (that.windowWidth = document.documentElement.clientWidth), //实时屏幕宽度
            (that.windowHeight = window.fullHeight); // 高
        })();
      };
    },
    methods:{
      formatDates(val){
          return formatDate(val)
      },
      columnStyle({ row, column, rowIndex, columnIndex}){
        
        return "word-break:break-word;padding-left:20px";
      },
        //翻页
      handleCurrentChange(updateCurrentPage) {
        this.currentPage = updateCurrentPage;
      },
      getlistByapproveProcess(){
          carbon.getlistByapproveProcess((res) => {
              if(res.code == 200){
                  this.tabList = res.data
              }
          },this.fromData);
      },
      save(){
          this.$router.push('/createAccount')
      },
      back(){
          this.$router.go(-1)   
      },
      gotoEdit(row){
          this.$router.push({
              path:'/approvalDetail',
              query:{
                  id:row.id
              }
          })
      }
    }
  };
  </script>
  <style lang="scss" scoped>
  .top_tlt{
    font-size: 40px;
    font-family: Arial-BoldMT, Arial;
    font-weight: bold;
    color: #1E1E1E;
    line-height: 45px;
    margin-bottom: 50px;
  }
  .createAccount_wrap {
    width: 1440px;
    height: 838px;
    background: #f8f9fa;
    margin: 0 auto;
    margin-top: 50px;
    border-radius: 20px;
    padding: 74px 42px 105px 52px;
    .save{
          width: 125px;
          height: 44px;
          background: #158869;
          border-radius: 4px;
          font-size: 16px;
          font-family: ArialMT;
          color: #FFFFFF;
      }
      .back{
          background-color: #F8F9FA;
          border-color: #97A5B7;
          color: #97A5B7;
      }
      .edit{
          width: 85px;
          height: 30px;
          border-radius: 4px;
          border: 1px solid #158869;
          color: #158869;
          font-size: 14px;
          font-family: ArialMT;
      }
      .delete{
          border: 1px solid #DC5F5F;
          color: #DC5F5F;
      }
      ::v-deep .el-button{
          padding: 0;
      }
  }
  .search{
      margin-bottom:50px;
      .search_t{
          font-size: 14px;
          font-weight: 600;
          color: #21212B;
          line-height: 16px;
          margin-bottom:10px;
      }
      .search_btn{
          width: 130px;
          height: 38px;
          border-radius: 8px;
          border: 1px solid #158869;
          font-size: 16px;
          color: #158869;
          line-height: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
      }
  }
  .flex_box{
    display: flex;
    // justify-content: center;
    align-items: center;
    cursor: pointer;
    .txt{
      font-size: 16px;
      font-family: ArialMT;
      margin-right: 18px;
    }
    .Reactive{
      color: #158869;
    }
    .Delete{
      color: #ED6666;
    }
    .Disable{
      color: rgba(0,20,42,0.65);
    }
  }
  </style>